module.exports = __webpack_public_path__ + "img/aboutUSHome.d5f5cf99.png";